// UISTATES - enumeration of possible uistates with coorelating CSS classes for values
export const UISTATES = {
    SELECT_DESTINATION: 'open-select-destination',
    CLOSED: 'closed'
};

// KEYCODES - browser keycodes
export const KEYCODES = {
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    ENTER: 13,
    SPACE: 32,
    TAB: 9,
    ESCAPE: 27
};

// destination default index value
export const NOT_SELECTED = -1;
